import { Typography, TYPOGRAPHY_WEIGHT } from '../../components/Typography'
import { Switch } from '../../components/Switch'
import { useCallback, useEffect, useState } from 'react'
import './styles.scss'
import {
  getNotificationsSetupRequest,
  updateNotificationsSetupRequest
} from './api'
import { setLoading } from '../../redux/store/common/slice'
import { useDispatch } from 'react-redux'

export const NotificationsSetup = () => {
  const [defaultChecked, setDefaultChecked] = useState<boolean>(false)
  const dispatch = useDispatch()

  useEffect(() => {
    getNotificationsSetup()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getNotificationsSetup = useCallback(async () => {
    const notificationsSetup = await getNotificationsSetupRequest()
    setDefaultChecked(notificationsSetup.data.is_emails_enabled)
  }, [])

  const onChange = useCallback(
    async (checked: boolean) => {
      try {
        dispatch(setLoading(true))

        const requestData = await updateNotificationsSetupRequest({
          is_emails_enabled: checked
        })
        if (requestData.data) {
          setDefaultChecked(requestData.data.is_emails_enabled)
        }
      } catch (e) {
        console.error(e)
      } finally {
        dispatch(setLoading(false))
      }
    },
    [dispatch]
  )

  return (
    <div className="notifications-setup">
      <div className="notifications-setup__row row gap-24 align-center">
        <Typography.Body2
          weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
          className="notifications-setup__left-column"
        >
          Email preferences
        </Typography.Body2>
        <div className="row gap-12 align-center">
          <Switch withLabels checked={defaultChecked} onChange={onChange} />
          <Typography.Body1>
            Send me emails for work item activity
          </Typography.Body1>
        </div>
      </div>
    </div>
  )
}
